(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    if (window.__pilaPackQty) return;
    window.__pilaPackQty = true;

    var selectedQty = null; // remembered across Dawn re-renders

    function qtyInput() {
      return document.querySelector('input.quantity__input[name="quantity"][form^="product-form-"]')
          || document.querySelector('input.quantity__input[name="quantity"]')
          || document.querySelector('.quantity__input');
    }
    function packsActive() { return !!document.querySelector('.pila-pack-qty-card'); }

    function highlight(n) {
      var s = String(n);
      document.querySelectorAll('.pila-pack-qty-card').forEach(function (card) {
        var on = card.getAttribute('data-qty') === s;
        card.classList.toggle('pila-pack-qty-card--active', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applyToInput(n) {
      var input = qtyInput();
      if (input && parseInt(input.value, 10) !== n) input.value = n;
    }

    function selectQty(n) {
      selectedQty = n;
      applyToInput(n);
      highlight(n);
    }

    // Re-assert the chosen pack. Dawn resets the quantity input to 1 when the
    // variant (color) changes and re-renders the section — this puts it back.
    function reapply() {
      if (selectedQty == null || !packsActive()) return;
      applyToInput(selectedQty);
      highlight(selectedQty);
    }
    function scheduleReapply() {
      [0, 60, 200, 500].forEach(function (t) { setTimeout(reapply, t); });
    }

    // Card click
    document.addEventListener('click', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.pila-pack-qty-card') : null;
      if (!card) return;
      selectQty(parseInt(card.getAttribute('data-qty'), 10));
    });

    // Variant/color change → re-assert after Dawn finishes its async re-render.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects, .product-form__input--swatch, .product-form__input--pill')) {
        scheduleReapply();
      }
    });

    // Catch any DOM re-render of the product section (node replacement).
    var pi = document.querySelector('product-info') || document.body;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; reapply(); });
    }).observe(pi, { childList: true, subtree: true });

    function init() {
      var input = qtyInput();
      if (input) highlight(parseInt(input.value, 10) || 1);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    if (window.__pilaInstallVideoInit) return;
    window.__pilaInstallVideoInit = true;

    var MODAL_ID = 'PilaInstallVideoModal';
    var modal = null, video = null, lastFocused = null, currentSrc = '';

    function build() {
      if (modal) return;
      modal = document.createElement('div');
      modal.className = 'pila-install-video__modal';
      modal.id = MODAL_ID;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML =
        '<div class="pila-install-video__backdrop" data-pila-iv-close></div>' +
        '<div class="pila-install-video__dialog">' +
          '<button type="button" class="pila-install-video__close" data-pila-iv-close aria-label="Close video">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg>' +
          '</button>' +
          '<video class="pila-install-video__video" controls playsinline preload="none"></video>' +
        '</div>';
      document.body.appendChild(modal);
      video = modal.querySelector('.pila-install-video__video');

      // Click anywhere that isn't the video itself (or the close button) closes.
      modal.addEventListener('click', function (e) {
        if (!e.target.closest('.pila-install-video__video') &&
            !e.target.closest('.pila-install-video__close')) {
          closeModal();
        }
      });
    }

    function openModal(trigger) {
      build();
      var src = trigger.getAttribute('data-iv-src') || '';
      var label = trigger.getAttribute('data-iv-label') || '';
      if (src && src !== currentSrc) { video.src = src; currentSrc = src; }
      if (label) modal.setAttribute('aria-label', label);
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pila-video-modal-open');
      try { video.currentTime = 0; } catch (e) {}
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      var closeBtn = modal.querySelector('.pila-install-video__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pila-video-modal-open');
      if (video) video.pause();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pila-iv-open]');
      if (opener) { e.preventDefault(); openModal(opener); return; }
      if (e.target.closest('[data-pila-iv-close]')) { e.preventDefault(); closeModal(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        e.preventDefault();
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neighborhood-program"]) return;
  try {
    
(function(){
  const total = 15, joined = 6;
  const row = document.getElementById('pila-npg-houseRow');
  const litSVG = (fill) => `
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 11L12 3L21 11" stroke="${fill}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 10V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V10" stroke="${fill}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="10" y="14" width="4" height="7" rx="0.5" stroke="${fill}" stroke-width="1.6"/>
    </svg>`;
  if (row) {
    for(let i=0;i<total;i++){
      const d = document.createElement('div');
      const isPulsing = i === joined; // the "next" house, mid-signup
      d.className = isPulsing ? 'pila-npg__house pila-npg__house--pulse' : 'pila-npg__house';
      d.innerHTML = litSVG(i < joined || isPulsing ? '#F8E08E' : '#3a3a36');
      row.appendChild(d);
    }
  }

  let pilaNpgIsNY = true;
  window.pilaNpgSetNY = function(isNY){
    pilaNpgIsNY = isNY;
    document.getElementById('pila-npg-btnNY').classList.toggle('active', isNY);
    document.getElementById('pila-npg-btnOther').classList.toggle('active', !isNY);
    document.getElementById('pila-npg-waitlistNote').classList.toggle('show', !isNY);
    document.getElementById('pila-npg-submitBtn').textContent = isNY ? 'Start my block' : 'Join the waitlist';
  };

  window.pilaNpgHandleSubmit = async function(e){
    e.preventDefault();
    const submitBtn = document.getElementById('pila-npg-submitBtn');
    const errorMsg = document.getElementById('pila-npg-errorMsg');
    errorMsg.classList.remove('show');

    const payload = {
      name: document.getElementById('pila-npg-nameInput').value,
      email: document.getElementById('pila-npg-emailInput').value,
      neighborhood: document.getElementById('pila-npg-neighborhoodInput').value,
      zip: document.getElementById('pila-npg-zipInput').value,
      neighbor_estimate: document.getElementById('pila-npg-estimateInput').value,
      in_ny: pilaNpgIsNY,
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    try {
      const resp = await fetch('https://project-b7v9b.vercel.app/api/neighborhood-signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!resp.ok) throw new Error('Request failed');

      document.getElementById('pila-npg-joinForm').style.display = 'none';
      document.querySelector('.pila-npg__toggle-row').style.display = 'none';
      document.getElementById('pila-npg-waitlistNote').classList.remove('show');
      document.getElementById('pila-npg-successMsg').classList.add('show');
    } catch (err) {
      console.error('Signup submit error:', err);
      errorMsg.classList.add('show');
      submitBtn.disabled = false;
      submitBtn.textContent = pilaNpgIsNY ? 'Start my block' : 'Join the waitlist';
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pila-comparison-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  // bind once on document — survives Dawn section re-renders
  if (window.__pilaCmpInfoBound) return;
  window.__pilaCmpInfoBound = true;

  document.addEventListener('click', function (e) {
    var row = e.target.closest('.pila-cmp__row');
    var hasInfo = !!(row && row.querySelector('.pila-cmp__info'));

    // close any popup that isn't the row just tapped
    document.querySelectorAll('.pila-cmp__row.is-info-open').forEach(function (r) {
      if (r !== row) r.classList.remove('is-info-open');
    });

    // toggle the tapped row's popup (only rows with info); taps elsewhere just close
    if (hasInfo) row.classList.toggle('is-info-open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pila-difference"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(module) {
      if (module.dataset.pilaDiffInit) return;
      module.dataset.pilaDiffInit = 'true';

      var bar = module.querySelector('.pila-difference__tabs');
      var wrap = module.querySelector('.pila-difference__tabs-wrap');
      var indicator = module.querySelector('.pila-difference__indicator');
      var tabs = [].slice.call(module.querySelectorAll('.pila-difference__tab'));
      var slides = [].slice.call(module.querySelectorAll('.pila-difference__slide'));
      var panels = [].slice.call(module.querySelectorAll('.pila-difference__panel'));
      var current = 0;
      var pending = null;

      if (!tabs.length) return;

      function moveIndicator() {
        var btn = tabs[current];
        if (!btn || !indicator) return;
        indicator.style.width = btn.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
        if (!indicator.classList.contains('is-ready')) {
          requestAnimationFrame(function () { indicator.classList.add('is-ready'); });
        }
      }

      function centerTab(btn) {
        if (!wrap || !btn) return;
        var overflow = wrap.scrollWidth - wrap.clientWidth;
        if (overflow <= 0) return;
        var target = btn.offsetLeft - (wrap.clientWidth - btn.offsetWidth) / 2;
        wrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }

      function swapSlide(newIndex) {
        if (newIndex === current || !slides.length) return;
        var dir = newIndex > current ? 1 : -1;
        var incoming = slides[newIndex];
        var outgoing = slides[current];

        if (pending) { clearTimeout(pending); pending = null; }

        // Normalize any slide that isn't part of this transition
        slides.forEach(function (s, i) {
          if (i !== current && i !== newIndex) {
            s.classList.remove('is-active');
            s.style.cssText = '';
          }
        });

        // Outgoing: take over with inline styles so it can drift out directionally
        outgoing.classList.remove('is-active');
        outgoing.style.transition = 'none';
        outgoing.style.opacity = '1';
        outgoing.style.transform = 'translateX(0)';
        outgoing.style.zIndex = '1';

        // Incoming: park just off the frame edge on the correct side
        incoming.classList.remove('is-active');
        incoming.style.transition = 'none';
        incoming.style.opacity = '1';
        incoming.style.transform = 'translateX(' + (dir * 100) + '%)';
        incoming.style.zIndex = '2';

        // Force reflow so the parked position registers before animating
        void incoming.offsetWidth;

        // Animate: incoming swipes in over outgoing, outgoing parallax-drifts + fades
        incoming.style.transition = '';
        outgoing.style.transition = '';
        incoming.style.transform = 'translateX(0)';
        outgoing.style.transform = 'translateX(' + (dir * -28) + '%)';
        outgoing.style.opacity = '0';

        var settled = newIndex;
        pending = setTimeout(function () {
          // Return to the clean, class-driven steady state
          slides.forEach(function (s) {
            s.classList.remove('is-active');
            s.style.cssText = '';
          });
          slides[settled].classList.add('is-active');
          pending = null;
        }, 680);

        current = newIndex;
      }

      function activate(index) {
        index = Math.max(0, Math.min(index, tabs.length - 1));
        if (index === current) { moveIndicator(); return; }
        swapSlide(index);
        tabs.forEach(function (t, i) {
          var on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, i) {
          p.classList.toggle('is-active', i === index);
        });
        moveIndicator();
        centerTab(tabs[index]);
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            var n = (i + 1) % tabs.length;
            tabs[n].focus();
            activate(n);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var p = (i - 1 + tabs.length) % tabs.length;
            tabs[p].focus();
            activate(p);
          }
        });
      });

      moveIndicator();
      window.addEventListener('resize', moveIndicator);
      window.addEventListener('load', moveIndicator);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(moveIndicator);
      }
      if ('ResizeObserver' in window && bar) {
        new ResizeObserver(moveIndicator).observe(bar);
      }

      // Let the theme editor jump to the panel whose block is being edited.
      module.__pilaDiffActivate = activate;
    }

    function initAll(root) {
      (root || document).querySelectorAll('.pila-difference').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    document.addEventListener('shopify:block:select', function (e) {
      var module = e.target.closest && e.target.closest('.pila-difference');
      if (!module || !module.__pilaDiffActivate) return;
      var btn = module.querySelector('.pila-difference__tab[data-block-id="' + e.detail.blockId + '"]');
      if (btn) module.__pilaDiffActivate(parseInt(btn.dataset.index, 10));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pila-partners-apply"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pilaPartnersApplyBound) return;
  window.__pilaPartnersApplyBound = true;

  function ppSelectType(card) {
    var typeName = card.getAttribute('data-pp-type');
    var owner = card.getAttribute('data-pp-owner');
    document.querySelectorAll('.pp-apply .pp-type-card').forEach(function (c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    var typeInput = document.getElementById('pp-partner-type');
    var ownerInput = document.getElementById('pp-routing-owner');
    if (typeInput) typeInput.value = typeName;
    if (ownerInput) ownerInput.value = owner;
    var fr = document.getElementById('pp-form-reveal');
    if (fr) fr.classList.add('open');
    setTimeout(function () { if (fr) fr.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
  }

  // Partner-type card selection (delegated)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.pp-apply .pp-type-card');
    if (card) ppSelectType(card);
  });

  // Multi-select pill state (delegated)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.pp-apply .pp-mc-opt input')) return;
    var label = input.closest('.pp-mc-opt');
    if (label) label.classList.toggle('checked', input.checked);
  });

  // Form submit (delegated)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'pp-form') return;
    e.preventDefault();

    var endpoint = form.getAttribute('data-pp-endpoint');
    var btn = document.getElementById('pp-submit-btn');
    var errEl = document.getElementById('pp-error');
    var originalText = btn ? btn.textContent : '';
    if (errEl) errEl.style.display = 'none';
    if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }

    var fd = new FormData(form);
    var payload = {
      company_name: fd.get('company_name'), website: fd.get('website'),
      contact_name: fd.get('contact_name'), email: fd.get('email'),
      phone: fd.get('phone'), partner_type: fd.get('partner_type'),
      routing_owner: fd.get('routing_owner'), regions: fd.getAll('regions'),
      interests: fd.getAll('interests'), annual_opportunities: fd.get('annual_opportunities'),
      referral_source: fd.get('referral_source'), notes: fd.get('notes')
    };

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('failed');
      form.style.display = 'none';
      var success = document.getElementById('pp-success-box');
      if (success) success.style.display = 'block';
    }).catch(function () {
      if (errEl) errEl.style.display = 'block';
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pila-partners"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pilaPartnersBound) return;
  window.__pilaPartnersBound = true;

  var PP_ENDPOINT = 'https://project-b7v9b.vercel.app/api/submit-partner';

  function ppSelectType(card) {
    var typeName = card.getAttribute('data-pp-type');
    var owner = card.getAttribute('data-pp-owner');
    document.querySelectorAll('.pp-type-card').forEach(function (c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    var typeInput = document.getElementById('pp-partner-type');
    var ownerInput = document.getElementById('pp-routing-owner');
    if (typeInput) typeInput.value = typeName;
    if (ownerInput) ownerInput.value = owner;
    var pillWrap = document.getElementById('pp-sel-pill-wrap');
    if (pillWrap) pillWrap.innerHTML = '<div class="pp-sel-pill">✓ ' + typeName + '</div>';
    var fr = document.getElementById('pp-form-reveal');
    if (fr) fr.classList.add('open');
    var hint = document.getElementById('pp-step-hint');
    if (hint) hint.style.display = 'none';
    setTimeout(function () { if (fr) fr.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
  }

  // Partner-type card selection (delegated)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.pp-type-card');
    if (card) ppSelectType(card);
  });

  // Multi-select pill state (delegated)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.pp-mc-opt input')) return;
    var label = input.closest('.pp-mc-opt');
    if (label) label.classList.toggle('checked', input.checked);
  });

  // Form submit (delegated)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'pp-form') return;
    e.preventDefault();

    var btn = document.getElementById('pp-submit-btn');
    var errEl = document.getElementById('pp-error');
    if (errEl) errEl.style.display = 'none';
    if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }

    var fd = new FormData(form);
    var payload = {
      company_name: fd.get('company_name'), website: fd.get('website'),
      contact_name: fd.get('contact_name'), email: fd.get('email'),
      phone: fd.get('phone'), partner_type: fd.get('partner_type'),
      routing_owner: fd.get('routing_owner'), regions: fd.getAll('regions'),
      interests: fd.getAll('interests'), annual_opportunities: fd.get('annual_opportunities'),
      referral_source: fd.get('referral_source'), notes: fd.get('notes')
    };

    fetch(PP_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('failed');
      form.style.display = 'none';
      var success = document.getElementById('pp-success-box');
      if (success) success.style.display = 'block';
    }).catch(function () {
      if (errEl) errEl.style.display = 'block';
      if (btn) { btn.disabled = false; btn.textContent = 'Submit application'; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pila-scenarios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(module) {
      if (module.dataset.pilaScenInit) return;
      module.dataset.pilaScenInit = 'true';

      var bar = module.querySelector('.pila-scenarios__tabs');
      var wrap = module.querySelector('.pila-scenarios__tabs-wrap');
      var indicator = module.querySelector('.pila-scenarios__indicator');
      var tabs = [].slice.call(module.querySelectorAll('.pila-scenarios__tab'));
      var slides = [].slice.call(module.querySelectorAll('.pila-scenarios__slide'));
      var panels = [].slice.call(module.querySelectorAll('.pila-scenarios__panel'));
      var current = 0;
      var pending = null;

      if (!tabs.length) return;

      // Play only the active clip; pause the rest. Hidden clips resume from
      // where they paused, so the visible loop is always seamless.
      function setVideo(index) {
        slides.forEach(function (s, i) {
          var v = s.querySelector('video');
          if (!v) return;
          if (i === index) {
            v.muted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function moveIndicator() {
        var btn = tabs[current];
        if (!btn || !indicator) return;
        indicator.style.width = btn.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
        if (!indicator.classList.contains('is-ready')) {
          requestAnimationFrame(function () { indicator.classList.add('is-ready'); });
        }
      }

      function centerTab(btn) {
        if (!wrap || !btn) return;
        var overflow = wrap.scrollWidth - wrap.clientWidth;
        if (overflow <= 0) return;
        var target = btn.offsetLeft - (wrap.clientWidth - btn.offsetWidth) / 2;
        wrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }

      function swapSlide(newIndex) {
        if (newIndex === current || !slides.length) return;
        var dir = newIndex > current ? 1 : -1;
        var incoming = slides[newIndex];
        var outgoing = slides[current];

        if (pending) { clearTimeout(pending); pending = null; }

        // Normalize any slide that isn't part of this transition
        slides.forEach(function (s, i) {
          if (i !== current && i !== newIndex) {
            s.classList.remove('is-active');
            s.style.cssText = '';
          }
        });

        // Outgoing: take over with inline styles so it can drift out directionally
        outgoing.classList.remove('is-active');
        outgoing.style.transition = 'none';
        outgoing.style.opacity = '1';
        outgoing.style.transform = 'translateX(0)';
        outgoing.style.zIndex = '1';

        // Incoming: park just off the frame edge on the correct side
        incoming.classList.remove('is-active');
        incoming.style.transition = 'none';
        incoming.style.opacity = '1';
        incoming.style.transform = 'translateX(' + (dir * 100) + '%)';
        incoming.style.zIndex = '2';

        // Force reflow so the parked position registers before animating
        void incoming.offsetWidth;

        // Animate: incoming swipes in over outgoing, outgoing parallax-drifts + fades
        incoming.style.transition = '';
        outgoing.style.transition = '';
        incoming.style.transform = 'translateX(0)';
        outgoing.style.transform = 'translateX(' + (dir * -28) + '%)';
        outgoing.style.opacity = '0';

        var settled = newIndex;
        pending = setTimeout(function () {
          // Return to the clean, class-driven steady state
          slides.forEach(function (s) {
            s.classList.remove('is-active');
            s.style.cssText = '';
          });
          slides[settled].classList.add('is-active');
          pending = null;
        }, 680);

        current = newIndex;
      }

      function activate(index) {
        index = Math.max(0, Math.min(index, tabs.length - 1));
        if (index === current) { moveIndicator(); return; }
        swapSlide(index);
        setVideo(index);
        tabs.forEach(function (t, i) {
          var on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, i) {
          p.classList.toggle('is-active', i === index);
        });
        moveIndicator();
        centerTab(tabs[index]);
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            var n = (i + 1) % tabs.length;
            tabs[n].focus();
            activate(n);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var p = (i - 1 + tabs.length) % tabs.length;
            tabs[p].focus();
            activate(p);
          }
        });
      });

      setVideo(0);
      moveIndicator();
      window.addEventListener('resize', moveIndicator);
      window.addEventListener('load', moveIndicator);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(moveIndicator);
      }
      if ('ResizeObserver' in window && bar) {
        new ResizeObserver(moveIndicator).observe(bar);
      }

      // Let the theme editor jump to the panel whose block is being edited.
      module.__pilaScenActivate = activate;
    }

    function initAll(root) {
      (root || document).querySelectorAll('.pila-scenarios').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    document.addEventListener('shopify:block:select', function (e) {
      var module = e.target.closest && e.target.closest('.pila-scenarios');
      if (!module || !module.__pilaScenActivate) return;
      var btn = module.querySelector('.pila-scenarios__tab[data-block-id="' + e.detail.blockId + '"]');
      if (btn) module.__pilaScenActivate(parseInt(btn.dataset.index, 10));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
